var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/SendButton/SendButton.jinja"] = require( "front/components/SendButton/SendButton.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/OhMyGod/OhMyGodPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/OhMyGod/OhMyGodPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"OhMyGodPopup Service\">\n    <div class=\"Service-headerWrapper\">\n        <h1 class=\"Service-header\">Сложные случаи</h1>\n        <a class=\"Service-close u-Route\" href=\"";
output += runtime.suppressValue((lineno = 5, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:index"])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue((lineno = 5, colno = 97, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["x",runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_5 = "";;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
return macro_t_4;})()})])), env.opts.autoescape);
output += "</a>\n    </div>\n    <div class=\"OhMyGodPopup-content Service-content Service-block\">\n        <div class=\"OhMyGodPopup-desc Service-text\">Мы поможем, если недвижимость под арестом или в залоге у банка, если\n            у вас материнский\n            капитал или военная ипотека, если нужно разрешение органов опеки, если вы в другой стране и не хотите\n            присутствовать на сделке или у вас другая трудность. Мы разбираемся в самых запутанных делах.\n        </div>\n        <form class=\"OhMyGodPopup-form\" action=\"\">\n            <textarea class=\"OhMyGodPopup-textarea OhMyGodPopup-block\"\n                      placeholder=\"Опишите задачу или проблему\"></textarea>\n            <div class=\"OhMyGodPopup-block\">\n                <input class=\"OhMyGodPopup-input\" name=\"name\" placeholder=\"Как к вам обращаться\">\n                <input class=\"OhMyGodPopup-input\" name=\"phone\" placeholder=\"Ваш номер телефона\">\n                ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/SendButton/SendButton.jinja", false, "assets/app/front/pages/OhMyGod/OhMyGodPopup.jinja", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
callback(null,t_6);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
callback(null,t_8);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n                <div class=\"OhMyGodPopup-callTime\">Перезвоним <span>сегодня до 18:00</span></div>\n            </div>\n        </form>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/OhMyGod/OhMyGodPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/OhMyGod/OhMyGodPopup.jinja
// module id = 96
// module chunks = 0